import { ComponentProps } from 'react';

import { mergeClasses } from '@/utils';

const TableCaption = ({ className, ...props }: ComponentProps<'caption'>) => {
  return (
    <caption
      data-slot="table-caption"
      className={mergeClasses('text-muted-foreground mt-4 text-body-sm', className)}
      {...props}
    />
  );
};

export default TableCaption;
